import apiClient from '../api.js';

// Capa de servicios del reporte de promedios por estudiante (`unicen.nota`).
// Backend en capas: `UNICEN/modules/academico`.
//
//   GET /academico/promedios?id_gestion=&id_sede=
//       -> { data: [ { unicodigo, cod_carrera, carrera, paterno, materno,
//                      nombres, estudiante, materias_cursadas,
//                      materias_aprobadas, promedio_gestion,
//                      materias_aprobadas_total, promedio_acumulado }, ... ] }
//
//       Una fila por estudiante y plan de estudio: un estudiante con notas en
//       dos carreras aparece dos veces. `promedio_gestion` es el promedio de
//       `nf` de todas las materias con nota en la gestión (si la gestión sigue
//       en curso es parcial); `promedio_acumulado`, el de las materias
//       aprobadas en todas las gestiones (criterio del Kardex). Ambos vienen en
//       null si no hay ninguna nota válida.
//
//       400 si falta `id_gestion` o `id_sede`, o no son numéricos.
//
// Solo lectura.

const resource = '/academico/promedios';

const usePromedioApi = {
  listarPromediosEstudiante({ id_gestion, id_sede }) {
    return apiClient.get(resource, { params: { id_gestion, id_sede } });
  },
};

export default usePromedioApi;
